export default __webpack_public_path__ + "static/media/52.9cec9b8d.jpg";